import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";

export interface IPayload {
    client_of?: number | null;
    manager_id?: number | null;
    group_filtering_id1?: number | null;
    group_filtering_id2?: number | null;
}

export interface IFirmContactInformationUpdate {
    contactId: number;
    payload: IPayload;
    deliveryMethod?: string | null;
}

@Injectable({
    providedIn: "root",
})
export class IFirmContactInformationService {
    private readonly iframeMessagesService = inject(IframeMessagesService);
    private readonly contactBatchSize = 100;

    constructor() {}

    async updateContacts(payload: IFirmContactInformationUpdate[]) {
        const responses = [];
        for (let start = 0; start < payload.length; start += this.contactBatchSize) {
            const result = await this.iframeMessagesService.postMessageResp(
                "updateiFirmContactsInformation",
                { payload: payload.slice(start, start + this.contactBatchSize) },
                "iFirmContactsInformationUpdated",
                300000,
            );
            if (result.status !== "success") {
                throw new Error("Failed to update document");
            }
            responses.push(result.response);
        }
        return responses;
    }
}
